export default "__VITE_PUBLIC_ASSET__3e62cbe8__"